import { memo } from "react";
import { animated, useTransition } from "react-spring";
import { TecorienLoader } from "../TecorienLoader";

import styles from "./style.module.scss";

export type FullscreenLoaderProps = {
  processId?: string | number
  description?: string
  progress?: number
}

export const FullscreenLoader = memo<FullscreenLoaderProps>(({ processId, description, progress }) => {
  const transitions = useTransition(!!processId, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: {
      duration: 250,
    },
  });
  return (
    <>
      {
        transitions((props, item) => item && (
          <animated.div style={props} className={styles.root}>
            <input className={styles.hiddenInput} autoFocus />
            <div className={styles.background} />
            <div className={styles.content}>
              <TecorienLoader className={styles.loader} description={description} progress={progress} />
            </div>
          </animated.div>
        ))
      }
    </>
  );
});

export default FullscreenLoader;
